import React from "react";
import styled from "styled-components";

export function Tabs({ value, defaultValue, onValueChange, children }) {
  const current = value ?? defaultValue;
  return (
    <TabsContext.Provider value={{ current, onValueChange }}>
      {children}
    </TabsContext.Provider>
  );
}

const TabsContext = React.createContext({
  current: undefined,
  onValueChange: () => {},
});

export function TabsList({ children }) {
  return (
    <TabsListWrap role="tablist">
      {children}
    </TabsListWrap>
  );
}

const TabsListWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #f3f4f6;
  padding: 4px;
  gap: 4px;
`;

export function TabsTrigger({ value, children }) {
  const { current, onValueChange } = React.useContext(TabsContext);
  const active = current === value;
  return (
    <TabButton
      type="button"
      $active={active}
      role="tab"
      aria-selected={active}
      onClick={() => onValueChange && onValueChange(value)}
    >
      {children}
    </TabButton>
  );
}

const TabButton = styled.button`
  border: none;
  border-radius: 9999px;
  padding: 6px 14px;
  font-size: 14px;
  font-weight: 600;
  background: ${({ $active }) => ($active ? "white" : "transparent")};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary.DEFAULT : theme.colors.text.body};
  cursor: pointer;
`;

export function TabsContent({ value, children }) {
  const { current } = React.useContext(TabsContext);
  if (current !== value) return null;
  return <div>{children}</div>;
}

